// extracted by mini-css-extract-plugin
export var closeButton = "_c3-1";
export var closeX = "_c3-3";
export var container = "_c3-0";
export var image = "_c3-2";